export default defineNuxtRouteMiddleware((to) => {
  // Only run on client side
  if (process.server) return;

  // Check if this is a magic link verification URL
  const urlParams = new URLSearchParams(to.fullPath.split('?')[1] || '');
  const token = urlParams.get('token');
  const type = urlParams.get('type');

  // If this is a magic link callback, let the auth system handle it
  if (token && type === 'magiclink') {
    console.log('[auth-callback middleware] Magic link detected, will be handled by useAuth');
    // Don't redirect here, let useAuth handle the verification and redirect
    return;
  }
});
